import { graphql } from 'react-relay';

export const getDrawingSetVersionTableQuery = graphql`
    query getDrawingSetVersionTableQuery($input: DrawingSetVersionTableInput!) {
        ...drawingSetVersionTableFragment @arguments(input: $input)
    }
`;
